var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10"},[_c('h3',[_vm._v("Transfer Recipients")]),_c('v-data-table',{attrs:{"title":"Transfer Recipients","items":_vm.transaction.bulk_transfer_recipient_details,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }